import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Rx';
import { AppConfig } from 'app/app.config';
import { environment } from 'environments/environment';


@Injectable()
export class AuthenticateService {

    public token: string;
    private headers: Headers = new Headers({'Content-Type': 'application/json'});

        constructor(private http: Http, private config: AppConfig) {
            // set token if saved in local storage
             const currentUser = JSON.parse(localStorage.getItem('currentUser'));
             this.token = currentUser && currentUser.token;
        }

        login(username: string, password: string) {
            // tslint:disable-next-line:max-line-length
            return this.http.post(environment.apiUrl + '/auth', JSON.stringify({ username: username, password: password }), {headers: this.headers})
                .map((response: Response) => {
                    // login successful if there's a jwt token in the response
                    const user = response.json();
                    if (user && user.token) {
                        // set token property
                        this.token = user.token;
                        // store username and jwt token in local storage to keep user logged in between page refreshes
                        // tslint:disable-next-line:max-line-length
                        localStorage.setItem('currentUser', JSON.stringify({ username: user.firstName + ' ' + user.lastName , token: user.token, rol:user.rol , conv_defecto:user.conv_defecto}));

                    }

                });

        }

        login_univ(username: string, password: string) {
            // tslint:disable-next-line:max-line-length
            return this.http.post(environment.apiUrl + '/universidad/auth', JSON.stringify({ username: username, password: password }), {headers: this.headers})
                .map((response: Response) => {
                    // login successful if there's a jwt token in the response
                    const user = response.json();
                    if (user && user.token) {
                        // set token property
                        this.token = user.token;
                        // store username and jwt token in local storage to keep user logged in between page refreshes
                        // tslint:disable-next-line:max-line-length
                        localStorage.setItem('currentUser', JSON.stringify({ username: user.firstName + ' ' + user.lastName , token: user.token, rol:user.rol, conv_defecto:user.conv_defecto }));

                    }

                });

        }

        register_univ(username: string) {
            // tslint:disable-next-line:max-line-length
            console.log(username);
            return this.http.post(environment.apiUrl + '/universidad/register',JSON.stringify({ documento: username}), {headers: this.headers})
                .map((response: Response) => {
                    // login successful if there's a jwt token in the response
                    const user = response.json();
                    console.log(user);
                });
        }


        register(username: string) {
            // tslint:disable-next-line:max-line-length
            console.log(username);
            return this.http.post(environment.apiUrl + '/register',JSON.stringify({ documento: username}), {headers: this.headers})
                .map((response: Response) => {
                    // login successful if there's a jwt token in the response
                    const user = response.json();
                    console.log(user);
                });
        }


        logout(): void {
            // clear token remove user from local storage to log user out
            this.token = null;
            localStorage.removeItem('currentUser');
            localStorage.removeItem('isLoggedin');
        }


}



// WEBPACK FOOTER //
// /app/src/app/services/authenticate.service.ts